import styled from 'styled-components'

export const GlobalSearchTriggerButtonShortcutStyled = styled.kbd`
  font-family: inherit;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  color: ${(props) => props.theme.colors.text.tertiary};
  white-space: nowrap;
`
